import React from "react";
import { useFormContext } from "react-hook-form";
import InputArea from "../../../common/components/FormFields/InputArea";

export default function ANCHighRiskFactors() {
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    // defaultValues: defaultValues,
  });
  return (
    <div>
      <div className="flex justify-between bg-[#FCDDCB] rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-2">High Risk Factors</p>
        <div className="flex my-auto"></div>
      </div>
      <div className="p-2 w-full border pb-2 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
        <InputArea
          control={control}
          label="High Risk Factors"
          name="highRiskAnc"
          sx={{
            color: "red",
            fontWeight: "bolder",
            minHeight: "7.75rem",
            ".css-1oih5lp-JoyTextarea-root": {},
          }}
          minRows={3}
        />
      </div>
    </div>
  );
}

